@if(loaded) {
    <router-outlet></router-outlet>
}